<template>
    <v-container fluid>
        <v-item-group>
            <v-row justify="center" align="center">
                <v-col
                    v-for="(membership, index) in memberships"
                    :key="membership.id"
                    cols="12"
                    :sm="memberships.length == 2 ? 6 : 12"
                    :md="
                        memberships.length == 1
                            ? 12
                            : memberships.length == 3
                            ? 4
                            : 6
                    "
                    class="flex justify-center pa-0"
                >
                    <v-item>
                        <FoundersClubCard
                            :membership="membership"
                            :title="membership.title"
                            :subtitle="membership.subtitle"
                            :heading="heading"
                            :image="membership.image"
                            :description="membership.description"
                            :button1="button1"
                            :button2="button2"
                            :recommended="membership.id == recommendation"
                            :width="memberships.length > 1 ? 350 : null"
                            @input="$emit('input', $event)"
                            @learnMore="$emit('learnMore', $event)"
                        />
                    </v-item>
                </v-col>
            </v-row>
        </v-item-group>
    </v-container>
</template>

<script>
import FoundersClubCard from "./FoundersClubCard.vue";

export default {
    components: {
        FoundersClubCard,
    },
    props: {
        memberships: {
            type: Array,
            default: () => [],
        },
        button1: {
            type: String,
            default: null,
        },
        button2: {
            type: String,
            default: null,
        },
        heading: {
            type: String,
            default: "Founders Membership",
        },
        pricingDetails: {
            type: Boolean,
            default: true,
        },
        recommendation: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            hover: false,
        };
    },
};
</script>
